import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    rightNav: {},
    noMenuPages: [ // 没有菜单的页面
      { path: '/dashboard', title: '首页' },
      { path: '/user/profile', title: '个人信息' },
      { path: '/user/changepwd', title: '修改密码' },
      { path: '/RegulatorWorkTask', title: '工作任务' },
      { path: '/RegulatorTrainTask', title: '培训任务' },
      { path: '/RegulatorPotentialTask', title: '隐患排查任务' },
      { path: '/RegulatorSafetyMeetingTask', title: '安全例会任务' },
      { path: '/Mail', title: '待办事项' },
      { path: '/UserRewardsPunishmentRecord', title: '奖惩记录' },
      { path: '/UserHomeVisitRecord', title:'家访记录' }
    ],
    tabnavBox: [
      {
        title: '首页',
        path: '/dashboard'
      }
    ]
  },
  mutations: {
    addTab (state, arg) {
      for (let i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      })
    },
    openMenu (state, arg) {
      state.rightNav = arg
    },
    removeTab (state, arg) {
      let index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path
      })
      state.tabnavBox.splice(index, 1)
      if (arg.tabItem.path === arg.fullPath) { // 移除当前导航时
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
    },
    removeOtherTab (state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }]
      if (arg.all) {
        arg.router.push('/dashboard')
        return false
      }
      state.tabnavBox.push(arg.tabItem)
      arg.router.push(arg.tabItem.path)
    },
    collapse (state, arg) {
      state.isCollapse = !state.isCollapse
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false
        }, 300)
      } else {
        state.logoShow = true
      }
    },

  },
  actions: {
    addTab ({ commit }, arg) {
      commit('addTab', arg)
    },
    openMenu ({ commit }, arg) {
      commit('openMenu', arg)
    },
    removeTab ({ commit }, arg) {
      commit('removeTab', arg)
    },
    removeOtherTab ({ commit }, arg) {
      commit('removeOtherTab', arg)
    },
    collapse ({ commit }, arg) {
      commit('collapse', arg)
    },
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js